import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

function LocationRebuildNotice({ show, label = "Success!", onClose = () => {} }) {
  return (
    <Modal isOpen={show} centered backdrop>
      <ModalHeader>{label}</ModalHeader>
      <ModalBody>
        <p className="text-center">
          Your change requires a location rebuild and should be <strong>available within 24 hours</strong>. You
          will receive an email notification once the change is complete.
        </p>
      </ModalBody>
      <ModalFooter style={{ justifyContent: "space-around" }}>
        <Button color="primary" className="promote" size="md" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default LocationRebuildNotice;